const test = {
	// utilityButton: "https://verification.diro.live/?buttonid=O.IN-AkxO0n-uQpq&trackid=",
	//BANK BUTTON LINK
	// bankButton : "https://session.diro.io/server/#/client/?buttonid=O.c6257a91-48c1-48a7-9f0b-e7724f25cabf-eVsb&trackid=", //url by Dhruv 
	bankButton : "https://verification.diro.live/?buttonid=O.IN-v6EsGi-pVOs&trackid=",                       // url by geetu 
	// bankButton : "https://diro.io/verification?buttonid=O.IN-ZGIvIV-UGzJ&trackid=",
    // bankButton : "https://verification.diro.live/?buttonid=O.IN-v6EsGi-gIhX&trackid=",
	// feedbackUrl: "https://api2.diro.live/cbre/api/sendsupportemail",
	feedbackUrl: "https://api2.diro.live/cbre/api/sendsupportemail",
	// frameSource: "https://session.diro.live/ https://verification.diro.live/",

	//bank button full doc
	// bankButtonFullDoc: "https://verification.diro.live/?buttonid=O.IN-AkxO0n-Rysn&trackid=",

	dirostatus: "https://stage2.diro.live/Zuul-1.0/organization-2.0/dirostatus",

	// staticUtilityButtonId: "O.IN-AkxO0n-uQpq",
	// staticBankOnlyButtonId: "O.c6257a91-48c1-48a7-9f0b-e7724f25cabf-eVsb",
	// staticBankOnlyButtonId:   "O.IN-ZGIvIV-pPJg",

	staticBankOnlyButtonId: "O.IN-v6EsGi-pVOs",
	
	// staticBankOnlyButtonId:"O.IN-ZGIvIV-UGzJ",
	// staticBankOnlyButtonId:"O.IN-v6EsGi-gIhX",


	// staticBankFullButtonId: "O.IN-AkxO0n-Rysn",

	sentryDSN: "https://1abf31a3b74de0d0e2db895888012b67@o1042621.ingest.sentry.io/4506835337543680",
	environment: "test",


};

const prod = {

	// utilityButton: "https://session.diro.io/server/#/client/?buttonid=O.c6257a91-48c1-48a7-9f0b-e7724f25cabf-lRgz&trackid=",
	//BANK BUTTON LINK
	// bankButton: "https://session.diro.io/server/#/client/?buttonid=O.c6257a91-48c1-48a7-9f0b-e7724f25cabf-1U9M&trackid=",
    bankButton : "https://session.diro.io/server/#/client/?buttonid=O.GB-86Abpu-sAx4&trackid=", //url by Dhruv 
	// https://session.diro.io/server/#/client/?buttonid=O.GB-86Abpu-sAx4&trackid=
	// https://diro.io/verification?buttonid=O.GB-86Abpu-sAx4&trackid=
    dirostatus: "https://prod.dirolabs.com/Zuul-1.0/organization-2.0/dirostatus",
	//bank button full doc
	// bankButtonFullDoc: "https://session.diro.io/server/#/client/?buttonid=O.c6257a91-48c1-48a7-9f0b-e7724f25cabf-8ZeY&trackid=",
	frameSource: "https://session.diro.io/ https://diro.io/",

	feedbackUrl: "https://api.diro.io/cbre/api/sendsupportemail",
	// feedbackUrl: "https://api2.diro.live/cbre/api/sendsupportemail",
	sentryDSN: "https://b4265ebeb50a201aa291c9c329bfbb05@o305199.ingest.us.sentry.io/4506874533576704",

	// staticUtilityButtonId: "O.c6257a91-48c1-48a7-9f0b-e7724f25cabf-lRgz",
	staticBankOnlyButtonId: "O.GB-86Abpu-sAx4",
	// staticBankOnlyButtonId: "O.c6257a91-48c1-48a7-9f0b-e7724f25cabf-1U9M",
	// staticBankFullButtonId: "O.c6257a91-48c1-48a7-9f0b-e7724f25cabf-8ZeY",

	environment: "prod",
};
export { test };
export { prod as env};
